export function pathUtil(id: any): string {
    let result = `${id}`;
    for (let i = result.length; i < 8; i++) {
        result = "0" + result;
    }
    return result;
}
